/**
 * @generated SignedSource<<f2ecc3cac7a5663807f68d5fca716913>>
 * @relayHash 5eb8cab2915315ec72fc29d2f2e615d6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskContactBuyerMutation

import { ConcreteRequest } from 'relay-runtime';
export type MessageOpopValidationMode = "SKIP_VALIDATION" | "VALIDATE_AND_IGNORE" | "VALIDATE_AND_THROW" | "%future added value";
export type MessageRedactionMode = "CHECK_AND_IGNORE_REDACTION" | "REDACT" | "SKIP_REDACTION" | "%future added value";
export type SaveMessageInput = {
  attachmentDir?: string | null;
  attempt?: number | null;
  clientMutationId?: string | null;
  conversationServiceId?: string | null;
  isFromMessageCenter?: boolean | null;
  isFromSeller: boolean;
  itemAttachmentIds?: ReadonlyArray<string | null> | null;
  itemId?: string | null;
  opopValidationMode?: MessageOpopValidationMode | null;
  pageContext?: string | null;
  recipientId?: string | null;
  redactionMode?: MessageRedactionMode | null;
  senderId: string;
  subject?: string | null;
  textBody: string;
  validateOPOPViolation?: boolean | null;
  videoAttachments?: ReadonlyArray<MessageVideoAttachmentInput | null> | null;
};
export type MessageVideoAttachmentInput = {
  assetId?: string | null;
  fileSize?: number | null;
  vimeoId?: string | null;
};
export type GetHelpZendeskContactBuyerMutation$variables = {
  input: SaveMessageInput;
};
export type GetHelpZendeskContactBuyerMutation$data = {
  readonly saveMessage: {
    readonly conversation: {
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type GetHelpZendeskContactBuyerMutation = {
  response: GetHelpZendeskContactBuyerMutation$data;
  variables: GetHelpZendeskContactBuyerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskContactBuyerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveMessagePayload",
        "kind": "LinkedField",
        "name": "saveMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskContactBuyerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SaveMessagePayload",
        "kind": "LinkedField",
        "name": "saveMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskContactBuyerMutation",
    "metadata": {},
    "name": "GetHelpZendeskContactBuyerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c856f7d4cde30838152ae50f6b138ce5";

export default node;
